<template>
    <el-col class="grid-stack-item">
        <div class="header">
            <h1>{{ $t('Club details') }}</h1>
        </div>
        <div class="my-content">
            <div class="grid-stack-item-content">

                    <div class="card-row">
                        <div class="action-list">
                            <label for="status" :class="(clubDetails.status == 'active'? 'act': 'in-act')">{{
                                $t(clubDetails.status) }}</label>
                        </div>
                        <div class="left-border-list">
                            <h3>{{ $t('Club') }}</h3>
                            <p>{{ clubDetails.display_name }}</p>
                        </div>
                    </div>
                    <div class="card-row">
                        <div class="left-border-list">
                            <h3>{{ $t('Organization') }}</h3>
                            <p>{{ clubDetails.organization_name }}</p>
                        </div>
                        <div class="left-border-list">
                            <h3>{{ $t('Address') }}</h3>
                            <p>{{ clubDetails.address }}</p>
                        </div>
                        <div class="left-border-list">
                            <h3>{{ $t('Place') }}</h3>
                            <p>{{ clubDetails.place }}</p>
                        </div>
                        <div class="left-border-list">
                            <h3>{{ $t('Zipcode') }}</h3>
                            <p>{{ clubDetails.zipcode }}</p>
                        </div>

                        <div class="left-border-list">
                            <h3>{{ $t('Website') }}</h3>
                            <p>{{ clubDetails.website ? clubDetails.website : '-' }}</p>
                        </div>

                        <div class="left-border-list">
                            <h3>{{ $t('Email') }}</h3>
                            <p>{{ clubDetails.email }}</p>
                        </div>
                        <div class="left-border-list">
                            <h3>{{ $t('Phone') }}</h3>
                            <p>{{ clubDetails.phone }}</p>
                        </div>
                    </div>
            </div>
        </div>
    </el-col>
</template>
<script>
    export default {
        props: {
            club_slug: String
        },
        data() {
            return {
                clubDetails: {}
            };
        },
        mounted() {
            request({
                    url: "clubs/" + this.club_slug,
                    method: "get",
                    params: {}
                })
                .then(response => {
                    this.clubDetails = response.data.data;
                })
                .catch(error => {

                });
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Layout/Clubs/ClubDetails.vue